import { render, staticRenderFns } from "./pfxz.vue?vue&type=template&id=3d405431&"
import script from "./pfxz.vue?vue&type=script&lang=js&"
export * from "./pfxz.vue?vue&type=script&lang=js&"
import style0 from "./pfxz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports